import React from "react"

import { NetworkAdUnit } from "./styles"

const RightRailAd = ({ nsfw, enforceShortAd = false, index, articleId }) => (
  <NetworkAdUnit
    className="right-rail-ad"
    unitName="Article_Right_Rail"
    nsfw={nsfw}
    position={`right-rail-${index || 1}`}
    articleId={articleId}
  />
)

export default RightRailAd
